import React from 'react';
import type { Banner } from './detail-page/banner';

/** The caller chooses the next action; this row never invents workflow gating. */
export function NextActionRow({
  title = 'Next action',
  children,
  action,
  tone = 'warning',
}: {
  title?: string;
  children: React.ReactNode;
  action: React.ReactElement;
  tone?: React.ComponentProps<typeof Banner>['tone'];
}) {
  return (
    <section
      data-next-action-row
      data-tone={tone}
      className="min-w-0 rounded-control border border-border bg-surface-sheet px-4 py-3 text-body"
    >
      <div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <p className="font-semibold">{title}</p>
          <div>{children}</div>
        </div>
        <div className="shrink-0 [&_button]:min-h-11 [&_a]:min-h-11">{action}</div>
      </div>
    </section>
  );
}
